import { Text } from "react-native";
import { convertDateToDDMMYYYY } from "ui/utils/dateUtils";
import { useMemo } from "react";
import { ResidentModel } from "app/services/api/types/residents/models/ResidentModel";

interface Props {
  date?: string;
  resident?: ResidentModel;
}

export default function DateAdmittedContent({ date, resident }: Props) {
  const formattedDate = useMemo(() => {
    return date ? convertDateToDDMMYYYY(date) : "No check in date";
  }, [date]);

  return <Text className="text-xs text-typography-600">{formattedDate}</Text>;
}
